import { Routes } from '@angular/router';
import { DashboardComponent } from '../components/dashboard/dashboard.component';
import { UsersComponent } from '../components/users/users.component';
import { FaqsComponent } from '../components/faqs/faqs.component';
import { TagsComponent } from '../components/tags/tags.component';
import { LocationsComponent } from '../components/locations/locations.component';
import { AttractionsComponent } from '../components/attractions/attractions.component';
import { OrganizationsComponent } from '../components/organizations/organizations.component';
import { GuidesComponent } from '../components/guides/guides.component';
import { LanguagesComponent } from '../components/languages/languages.component';
import { DocsComponent } from '../components/docs/docs.component';
import { UserViewComponent } from '../components/users/user-view/user-view.component';
import { NewFaqComponent } from '../components/faqs/new-faq/new-faq.component';
import { FaqViewComponent } from '../components/faqs/faq-view/faq-view.component';
import { TagViewComponent } from '../components/tags/tag-view/tag-view.component';
import { NewTagComponent } from '../components/tags/new-tag/new-tag.component';
import { NewLocationComponent } from '../components/locations/new-location/new-location.component';
import { LocationViewComponent } from '../components/locations/location-view/location-view.component';
import { NewAttractionComponent } from '../components/attractions/new-attraction/new-attraction.component';
import { AttractionViewComponent } from '../components/attractions/attraction-view/attraction-view.component';
import { NewOrganizationComponent } from '../components/organizations/new-organization/new-organization.component';
import { OrganizationViewComponent } from '../components/organizations/organization-view/organization-view.component';
import { NewGuideComponent } from '../components/guides/new-guide/new-guide.component';
import { GuideViewComponent } from '../components/guides/guide-view/guide-view.component';
import { NewLanguageComponent } from '../components/languages/new-language/new-language.component';
import { LanguageViewComponent } from '../components/languages/language-view/language-view.component';
import { NewDocComponent } from '../components/docs/new-doc/new-doc.component';
import { DocViewComponent } from '../components/docs/doc-view/doc-view.component';
import { AdminGuard } from '../_guards/admin.guard';
import { DataComponent } from '../components/data/data.component';
import { ServicesComponent } from '../components/services/services.component';
import { ServiceViewComponent } from '../components/services/services-view/service-view.component';
import { NewServiceComponent } from '../components/services/new-services/new-service.component';
import { ReviewsComponent } from '../components/reviews/reviews.component';
import { ReviewViewComponent } from '../components/reviews/review-view/review-view.component';
import { NewReviewComponent } from '../components/reviews/new-review/new-review.component';
import { DzongkhaComponent } from '../components/dzongkha/dzongkha.component';
import { DzongkhaViewComponent } from '../components/dzongkha/dzongkha-view/dzongkha-view.component';
import { NewDzongkhaComponent } from '../components/dzongkha/new-dzongkha/new-dzongkha.component';
import { ReportsComponent } from '../components/reports/reports.component';
import { AllPhotosComponent } from '../components/all-photos/all-photos.component';
import { NewUserComponent } from '../components/users/new-user/new-user.component';
import { AllVideosComponent } from '../components/all-videos/all-videos.component';
import { ContactInquiriesComponent } from '../components/contact-inquiries/contact-inquiries.component';
import { ContactInquiryViewComponent } from '../components/contact-inquiries/contact-inquiry-view/contact-inquiry-view.component';
import { TeamsComponent } from '../components/teams/teams.component';
import { NewTeamComponent } from '../components/teams/new-team/new-team.component';
import { TeamViewComponent } from '../components/teams/team-view/team-view.component';




export const ADMIN_ROUTES: Routes = [
  {
    path: '', component: DashboardComponent, canActivate: [AdminGuard], children: [
    {path: 'users', canActivate: [AdminGuard], component: UsersComponent},
    {path: 'users/new', canActivate: [AdminGuard], component: NewUserComponent},
    {path: 'users/:id', canActivate: [AdminGuard], component: UserViewComponent},
    {path: 'faqs', canActivate: [AdminGuard], component: FaqsComponent},
    {path: 'faqs/view/:id', canActivate: [AdminGuard], component: FaqViewComponent},
    {path: 'faqs/new', canActivate: [AdminGuard], component: NewFaqComponent},
    {path: 'tags', canActivate: [AdminGuard], component: TagsComponent},
    {path: 'tags/view/:id', canActivate: [AdminGuard], component: TagViewComponent},
    {path: 'tags/new', canActivate: [AdminGuard], component: NewTagComponent},
    {path: 'locations', canActivate: [AdminGuard], component: LocationsComponent},
    {path: 'locations/new', canActivate: [AdminGuard], component: NewLocationComponent},
    {path: 'locations/view/:id', canActivate: [AdminGuard], component: LocationViewComponent},
    {path: 'attractions', canActivate: [AdminGuard], component: AttractionsComponent},
    {path: 'attractions/new', canActivate: [AdminGuard], component: NewAttractionComponent},
    {path: 'attractions/view/:id', canActivate: [AdminGuard], component: AttractionViewComponent},
    {path: 'organizations', canActivate: [AdminGuard], component: OrganizationsComponent},
    {path: 'organizations/new', canActivate: [AdminGuard], component: NewOrganizationComponent},
    {path: 'organizations/view/:id', canActivate: [AdminGuard], component: OrganizationViewComponent},
    {path: 'guides', canActivate: [AdminGuard], component: GuidesComponent},
    {path: 'guides/new', canActivate: [AdminGuard], component: NewGuideComponent},
    {path: 'guides/view/:id', canActivate: [AdminGuard], component: GuideViewComponent},
    {path: 'languages', canActivate: [AdminGuard], component: LanguagesComponent},
    {path: 'languages/new', canActivate: [AdminGuard], component: NewLanguageComponent},
    {path: 'languages/view/:id', canActivate: [AdminGuard], component: LanguageViewComponent},
    {path: 'docs', canActivate: [AdminGuard], component: DocsComponent},
    {path: 'docs/new', canActivate: [AdminGuard], component: NewDocComponent},
    {path: 'docs/view/:id', canActivate: [AdminGuard], component: DocViewComponent},
    {path: 'services', canActivate: [AdminGuard], component: ServicesComponent},
    {path: 'services/view/:id', canActivate: [AdminGuard], component: ServiceViewComponent},
    {path: 'services/new', canActivate: [AdminGuard], component: NewServiceComponent},
    {path: 'reviews', canActivate: [AdminGuard], component: ReviewsComponent},
    {path: 'reviews/:organizationId', canActivate: [AdminGuard], component: ReviewsComponent},
    {path: 'reviews/view/:id', canActivate: [AdminGuard], component: ReviewViewComponent},
    {path: 'reviews/new/:organizationId', canActivate: [AdminGuard], component: NewReviewComponent},
    {path: 'dzongkhas', canActivate: [AdminGuard], component: DzongkhaComponent},
    {path: 'dzongkhas/view/:id', canActivate: [AdminGuard], component: DzongkhaViewComponent},
    {path: 'dzongkhas/new', canActivate: [AdminGuard], component: NewDzongkhaComponent},
    {path: 'reports', canActivate: [AdminGuard], component: ReportsComponent},
    {path: 'all-photos', canActivate: [AdminGuard], component: AllPhotosComponent},
    {path: 'all-videos', canActivate: [AdminGuard], component: AllVideosComponent},
    {path: 'contact-inquiries', canActivate: [AdminGuard], component: ContactInquiriesComponent},
    {path: 'contact-inquiries/:id', canActivate: [AdminGuard], component: ContactInquiryViewComponent},
    {path: 'teams', canActivate: [AdminGuard], component: TeamsComponent},
    {path: 'teams/new', canActivate: [AdminGuard], component: NewTeamComponent},
    {path: 'teams/view/:id', canActivate: [AdminGuard], component: TeamViewComponent},

  ]
  },
  {path: 'data', component: DataComponent}
];



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/constants/admin.routes.ts